var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g4, _path26, _path27, _path28, _g5, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.872 101.792C34.1328 101.154 33.4696 100.265 33.8824 99.4356C34.1369 98.9246 39.5041 94.1679 40.576 93.7756L61.9338 88.4903C64.745 87.459 69.346 87.459 72.1475 88.4903L93.6553 93.8476C94.7281 94.2399 99.9432 98.9246 100.198 99.4356C100.611 100.265 99.9471 101.154 98.2067 101.792L72.1475 111.346C69.3362 112.377 64.7353 112.377 61.9338 111.346L35.872 101.792Z",
    fill: "#2D3033",
    stroke: "black",
    strokeWidth: 0.240622,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17822_31253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 87,
    width: 68,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.872 101.792C34.1328 101.154 33.4696 100.265 33.8824 99.4356C34.1369 98.9246 39.5041 94.1679 40.576 93.7756L61.9338 88.4903C64.745 87.459 69.346 87.459 72.1475 88.4903L93.6553 93.8476C94.7281 94.2399 99.9432 98.9246 100.198 99.4356C100.611 100.265 99.9471 101.154 98.2067 101.792L72.1475 111.346C69.3362 112.377 64.7353 112.377 61.9338 111.346L35.872 101.792Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17822_31253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2222 115.904C68.7463 115.904 70.2684 115.703 71.417 115.27L99.6453 104.775C100.8 104.353 101.377 103.793 101.377 103.236V93.9328C101.377 93.9328 92.7666 93.0303 94.4774 94.1596C96.7548 95.663 92.895 97.1738 92.895 97.1738L70.2824 105.509C68.5965 106.128 67.2162 108.115 67.2162 109.921L67.2222 115.904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1208 107.035L44.2689 103.529C43.1277 103.123 41.8599 103.33 40.9046 104.079L55.7805 109.398C55.7805 108.336 55.1154 107.388 54.1208 107.035Z",
    fill: "#F66754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.872 101.792C34.1328 101.154 33.4696 100.265 33.8824 99.4356C34.1369 98.9246 39.5041 94.1679 40.576 93.7756L61.9338 88.4903C64.745 87.459 69.346 87.459 72.1475 88.4903L93.6553 93.8476C94.7281 94.2399 99.9432 98.9246 100.198 99.4356C100.611 100.265 99.9471 101.154 98.2067 101.792L72.1475 111.346C69.3362 112.377 64.7353 112.377 61.9338 111.346L35.872 101.792Z",
    stroke: "black",
    strokeWidth: 0.240622,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5666 96.3075C39.269 95.4646 39.269 94.0851 41.5666 93.2442L62.8668 85.4359C65.1644 84.593 68.9247 84.593 71.2144 85.4359L92.5126 93.2442C94.8121 94.0851 94.8121 95.4646 92.5126 96.3075L71.2144 104.116C68.9168 104.959 65.1564 104.959 62.8668 104.116L41.5666 96.3075Z",
    fill: "#2D3033",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3431 96.0205C44.4763 95.3357 44.4763 94.2148 46.3431 93.5316L63.6493 87.1874C65.5161 86.5026 68.5713 86.5026 70.4317 87.1874L87.7363 93.5316C89.6047 94.2148 89.6047 95.3357 87.7363 96.0205L70.4317 102.365C68.5649 103.05 65.5096 103.05 63.6493 102.365L46.3431 96.0205Z",
    stroke: "#777E87",
    strokeWidth: 0.481244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.409 35.5135C109.409 33.9357 107.872 32.4503 105.363 31.8417L74.238 24.2728C70.972 23.4794 67.2951 24.4756 66.0237 26.4975L36.3023 73.7547C36.0287 74.1735 35.8797 74.6686 35.8742 75.177L35.8528 79.1012C35.8528 80.679 37.3852 82.1711 39.8978 82.7819L71.0234 90.3486C74.2872 91.142 77.9663 90.1458 79.2376 88.1262L108.961 40.8689C109.235 40.4508 109.384 39.9565 109.39 39.4489L109.411 35.5247C109.411 35.5247 109.409 35.518 109.409 35.5135Z",
    fill: "#E9EFF5",
    stroke: "black",
    strokeWidth: 0.240622,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17822_31253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 23,
    width: 75,
    height: 68
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.409 35.5135C109.409 33.9357 107.872 32.4503 105.363 31.8417L74.238 24.2728C70.972 23.4794 67.2951 24.4756 66.0237 26.4975L36.3023 73.7547C36.0287 74.1735 35.8797 74.6686 35.8742 75.177L35.8528 79.1012C35.8528 80.679 37.3852 82.1711 39.8978 82.7819L71.0234 90.3486C74.2872 91.142 77.9663 90.1458 79.2376 88.1262L108.961 40.8689C109.235 40.4508 109.384 39.9565 109.39 39.4489L109.411 35.5247C109.411 35.5247 109.409 35.518 109.409 35.5135Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.240622,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17822_31253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.409 35.5135C109.409 33.9357 107.872 32.4503 105.363 31.8417L74.238 24.2728C70.972 23.4794 67.2951 24.4756 66.0237 26.4975L36.3023 73.7547C36.0287 74.1735 35.8797 74.6686 35.8742 75.177L35.8528 79.1012C35.8528 80.679 37.3852 82.1711 39.8978 82.7819L71.0234 90.3486C74.2872 91.142 77.9663 90.1458 79.2376 88.1262L108.961 40.8689C109.235 40.4508 109.384 39.9565 109.39 39.4489L109.411 35.5247C109.411 35.5247 109.409 35.518 109.409 35.5135Z",
    fill: "#2E3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3023 73.7545C36.0287 74.1734 35.8797 74.6685 35.8742 75.1768L35.8528 79.101C35.8528 80.6788 37.3852 82.1709 39.8978 82.7818L71.0234 90.3484C72.1728 90.623 73.358 90.6916 74.5291 90.5513V84.63L37.58 71.7349L36.3023 73.7545Z",
    fill: "#222427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.363 31.853C108.629 32.6464 110.245 34.9297 108.974 36.9516L79.2528 84.2088C77.9836 86.2374 74.3046 87.2269 71.0386 86.4335L39.913 78.8645C36.6491 78.0711 35.0311 75.7878 36.3025 73.766L66.0239 26.5088C67.2953 24.4802 70.9722 23.4907 74.2382 24.2841L105.363 31.853Z",
    fill: "#505356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7085 86.9247C62.9638 86.9247 63.1708 86.7067 63.1708 86.4378C63.1708 86.1689 62.9638 85.9509 62.7085 85.9509C62.4532 85.9509 62.2462 86.1689 62.2462 86.4378C62.2462 86.7067 62.4532 86.9247 62.7085 86.9247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2987 87.3123C64.554 87.3123 64.761 87.0944 64.761 86.8255C64.761 86.5566 64.554 86.3386 64.2987 86.3386C64.0434 86.3386 63.8364 86.5566 63.8364 86.8255C63.8364 87.0944 64.0434 87.3123 64.2987 87.3123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8889 87.6978C66.1443 87.6978 66.3512 87.4799 66.3512 87.211C66.3512 86.9421 66.1443 86.7241 65.8889 86.7241C65.6336 86.7241 65.4266 86.9421 65.4266 87.211C65.4266 87.4799 65.6336 87.6978 65.8889 87.6978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4771 88.0854C67.7324 88.0854 67.9394 87.8674 67.9394 87.5985C67.9394 87.3296 67.7324 87.1116 67.4771 87.1116C67.2217 87.1116 67.0148 87.3296 67.0148 87.5985C67.0148 87.8674 67.2217 88.0854 67.4771 88.0854Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7583 81.5533C41.0136 81.5533 41.2206 81.3354 41.2206 81.0665C41.2206 80.7976 41.0136 80.5796 40.7583 80.5796C40.503 80.5796 40.296 80.7976 40.296 81.0665C40.296 81.3354 40.503 81.5533 40.7583 81.5533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3484 81.941C42.6037 81.941 42.8107 81.7231 42.8107 81.4542C42.8107 81.1853 42.6037 80.9673 42.3484 80.9673C42.0931 80.9673 41.8861 81.1853 41.8861 81.4542C41.8861 81.7231 42.0931 81.941 42.3484 81.941Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9364 82.3265C44.1917 82.3265 44.3987 82.1085 44.3987 81.8397C44.3987 81.5708 44.1917 81.3528 43.9364 81.3528C43.6811 81.3528 43.4741 81.5708 43.4741 81.8397C43.4741 82.1085 43.6811 82.3265 43.9364 82.3265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5267 82.7142C45.782 82.7142 45.989 82.4963 45.989 82.2274C45.989 81.9585 45.782 81.7405 45.5267 81.7405C45.2713 81.7405 45.0645 81.9585 45.0645 82.2274C45.0645 82.4963 45.2713 82.7142 45.5267 82.7142Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9112 77.2293C40.6086 76.9133 39.6548 76.3039 39.1515 75.5925ZM106.227 34.905C106.725 35.6083 106.788 36.416 106.307 37.1817ZM39.1515 75.5925C38.6538 74.8889 38.5904 74.0808 39.0693 73.3152Z",
    stroke: "#2E3033",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7838 30.2244L85.4322 33.4809L84.3194 35.2374L69.671 31.981L70.7838 30.2244Z",
    fill: "#2E3033"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8479 34.7366L98.2478 42.0045L97.135 43.761L66.7351 36.4931L67.8479 34.7366Z",
    fill: "#2E3033"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7435 39.3904L90.1687 45.3155L89.0559 47.072L63.6307 41.1469L64.7435 39.3904Z",
    fill: "#2E3033"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5178 44.0923L91.9176 51.3602L90.8048 53.1167L60.405 45.8488L61.5178 44.0923Z",
    fill: "#2E3033"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2849 49.0706L78.5603 53.6771L77.4475 55.4336L57.1719 50.8272L58.2849 49.0706Z",
    fill: "#2E3033"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9141 58.9143L83.3139 66.1821L82.201 67.9387L51.8013 60.6708L52.9141 58.9143Z",
    fill: "#2E3033"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6226 64.0125L80.0224 71.2803L78.9096 73.037L48.5098 65.7691L49.6226 64.0125Z",
    fill: "#2E3033"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3389 68.8264L65.6143 73.4328L64.5015 75.1894L44.2261 70.5829L45.3389 68.8264Z",
    fill: "#2E3033"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.409 35.5135C109.409 33.9357 107.872 32.4503 105.363 31.8417L74.238 24.2728C70.972 23.4794 67.2951 24.4756 66.0237 26.4975L36.3023 73.7547C36.0287 74.1735 35.8797 74.6686 35.8742 75.177L35.8528 79.1012C35.8528 80.679 37.3852 82.1711 39.8978 82.7819L71.0234 90.3486C74.2872 91.142 77.9663 90.1457 79.2376 88.1262L108.961 40.8689C109.235 40.4508 109.384 39.9565 109.39 39.4489L109.411 35.5247C109.411 35.5247 109.409 35.518 109.409 35.5135Z",
    stroke: "black",
    strokeWidth: 0.240622,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17822_31253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 23,
    width: 75,
    height: 68
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.409 35.5135C109.409 33.9357 107.872 32.4503 105.363 31.8417L74.238 24.2728C70.972 23.4794 67.2951 24.4756 66.0237 26.4975L36.3023 73.7547C36.0287 74.1735 35.8797 74.6686 35.8742 75.177L35.8528 79.1012C35.8528 80.679 37.3852 82.1711 39.8978 82.7819L71.0234 90.3486C74.2872 91.142 77.9663 90.1457 79.2376 88.1262L108.961 40.8689C109.235 40.4508 109.384 39.9565 109.39 39.4489L109.411 35.5247C109.411 35.5247 109.409 35.518 109.409 35.5135Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17822_31253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7912 65.3591L37.8033 68.5515C37.8033 68.5515 43.8713 70.3281 49.8795 69.5312C55.8877 68.7344 61.402 67.2848 61.402 67.2848L39.7912 65.3591Z",
    fill: "black"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.035 66.8917C27.0786 63.9856 19.0644 57.3162 16.42 43.9336C17.7524 43.7882 19.2015 43.6701 20.7435 43.5445C26.9586 43.0381 34.6835 42.4087 42.3678 39.3669C44.0622 49.1187 48.6931 59.4455 61.1228 67.2948C54.7017 68.9568 44.9045 69.7696 36.035 66.8917Z",
    fill: "#404346",
    stroke: "black",
    strokeWidth: 0.240622,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7999 47.0441C26.5159 46.8034 35.8563 45.1556 39.3358 44.2051",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.699 49.5388C27.1212 49.2347 31.3388 48.5589 35.0294 47.7908",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9963 54.4832C30.4963 54.4832 38.9573 52.5469 42.4369 51.5964",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.017 56.8652C32.845 56.5825 40.1923 54.9323 43.6718 53.9817",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3273 59.1931C34.8441 58.9255 41.799 57.3634 45.0928 56.4636",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6924 61.4387C34.3721 61.2711 37.6885 60.8056 40.7875 60.0388",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4463 64.9403C42.8685 64.6362 47.0861 63.9605 50.7766 63.1924",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5491 66.652C43.875 66.652 44.9475 66.4465 47.4918 66.0193",
    stroke: "#2E3033",
    strokeWidth: 0.962489,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_17822_31253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 39,
    width: 46,
    height: 30
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0441 66.8633C27.1037 63.9625 19.1036 57.3092 16.4552 43.9595C17.7777 43.8158 19.2149 43.6987 20.7439 43.5742C26.9501 43.0686 34.6672 42.4399 42.3449 39.4077C44.043 49.1403 48.6697 59.4426 61.049 67.2831C54.6306 68.9326 44.8763 69.7291 36.0441 66.8633Z",
    fill: "#404346",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_17822_31253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5354 69.1661C43.3576 68.9129 35.4711 67.8409 29.4032 65.0428C30.312 64.9537 31.5469 64.7225 32.8237 64.2715C34.3426 63.735 35.9328 62.8833 37.1018 61.5779C38.5831 63.5397 42.4549 67.4084 47.5354 69.1661Z",
    fill: "#2E3033",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.035 66.8917C27.0786 63.9856 19.0644 57.3162 16.42 43.9336C17.7524 43.7882 19.2015 43.6701 20.7435 43.5445C26.9586 43.0381 34.6835 42.4087 42.3678 39.3669C44.0622 49.1187 48.6931 59.4455 61.1228 67.2948C54.7017 68.9568 44.9045 69.7696 36.035 66.8917Z",
    stroke: "black",
    strokeWidth: 0.240622,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 84.485L95.8486 75.3091L100.33 67.1163L110.938 65.666L115.413 74.8414L110.932 83.0328L100.323 84.485Z",
    fill: "#404346",
    stroke: "black",
    strokeWidth: 0.240622
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_17822_31253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 65,
    width: 21,
    height: 20
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.34 84.4526L95.8819 75.3098L100.349 67.1436L110.921 65.6982L115.38 74.8405L110.913 83.0053L100.34 84.4526Z",
    fill: "#404346",
    stroke: "black",
    strokeWidth: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_17822_31253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.58 73.964L110.95 65.6646L115.403 74.8331L110.95 83.0484L106.58 73.964Z",
    fill: "#2E3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.995 65.595L106.608 73.9528M106.608 73.9528L95.8286 75.3472M106.608 73.9528L110.884 82.9982",
    stroke: "black",
    strokeWidth: 0.3
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2061 76.5433L105.419 75.6128L106.658 78.2934L99.4458 79.224L98.2061 76.5433Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9332 80.2996L107.145 79.3691L108.385 82.0497L101.172 82.9802L99.9332 80.2996Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7347 77.4741L100.81 77.3438",
    stroke: "#66DD8C",
    strokeWidth: 0.721866,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M102.248 77.1043L104.665 76.8262",
    stroke: "#66DD8C",
    strokeWidth: 0.721866,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.794 81.0323L103.868 80.9019",
    stroke: "#66DD8C",
    strokeWidth: 0.721866,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M105.251 80.67L106.326 80.5396",
    stroke: "#66DD8C",
    strokeWidth: 0.721866,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.323 84.485L95.8486 75.3091L100.33 67.1163L110.938 65.666L115.413 74.8414L110.932 83.0328L100.323 84.485Z",
    stroke: "black",
    strokeWidth: 0.240622
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.fe52b6bbe34dcf78f18f73222a5e1202.svg";
export { ForwardRef as ReactComponent };